import React from 'react';
import { Briefcase, Shield, Users, Target } from 'lucide-react';
export function TimelineSection() {
  const timelineItems = [{
    icon: <Briefcase className="h-6 w-6 text-white" data-id="element-219" data-mp="v6htj6lq7szz" />,
    color: 'bg-blue-600',
    title: 'Founder & CEO, FiQIS',
    subtitle: 'Current Role',
    description: 'Leading the development of next-generation financial infrastructure. Architecting modular banking systems designed to replace outdated legacy technology with scalable, secure solutions.'
  }, {
    icon: <Shield className="h-6 w-6 text-white" data-id="element-220" data-mp="1e2q3uotliu25" />,
    color: 'bg-slate-800',
    title: 'Post-Quantum Security Focus',
    subtitle: 'Core Initiative',
    description: 'Pioneering the integration of post-quantum encryption into core banking infrastructure before launch, ensuring financial systems are prepared for future cryptographic threats.'
  }, {
    icon: <Target className="h-6 w-6 text-white" data-id="element-221" data-mp="1wusd3f3wr82d" />,
    color: 'bg-blue-500',
    title: 'Building Smarter Credit',
    subtitle: 'Product Vision',
    description: 'Moving beyond traditional BNPL (Buy Now, Pay Later) models to build smarter, more resilient credit systems that benefit both institutions and end consumers.'
  }, {
    icon: <Users className="h-6 w-6 text-white" data-id="element-222" data-mp="306cjn3zs9v16" />,
    color: 'bg-slate-600',
    title: 'Servant Leadership & Ethics',
    subtitle: 'Leadership Philosophy',
    description: 'Fostering a culture of ethical innovation. Balancing rapid AI and security advancements with a steadfast commitment to human impact, transparency, and stakeholder engagement.'
  }];
  return <section id="experience" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8" data-id="element-223" data-mp="3iwkhp7omlvai">
      <div className="max-w-4xl mx-auto" data-id="element-224" data-mp="3nvnbfvz5of36">
        <div className="text-center mb-16" data-id="element-225" data-mp="3rvo0eajvs8oh">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-226" data-mp="3rwz4kbh8nig4">
            Career & Leadership Focus
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-6" data-id="element-227" data-mp="midqjk4fh25"></div>
          <p className="text-lg text-slate-400" data-id="element-228" data-mp="1sqnyoa5upsim">
            Key pillars driving the vision and execution at FiQIS.
          </p>
        </div>

        <div className="relative" data-id="element-229" data-mp="26ikmw34efi9q">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-white/10" data-id="element-230" data-mp="21qkfxqpwvp3n"></div>

          <div className="space-y-12" data-id="element-231" data-mp="2genon7vc9ew5">
            {timelineItems.map((item, index) => <div key={index} className={`relative flex flex-col md:flex-row items-start ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-232" data-mp="2bfuarec53lvg" data-mpi={index}>
                {/* Center Icon */}
                <div className="absolute left-4 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full border-4 border-[#0d1321] z-10 shadow-sm mt-1 md:mt-0" style={{
              backgroundColor: '#22D3EE' /* cyan-400 */
            }} data-id="element-233" data-mp="2kidahpkmpidh">
                  <div className={`w-full h-full rounded-full flex items-center justify-center bg-[#0B1120]`} data-id="element-234" data-mp="36ppr0viwyysx">
                    {item.icon}
                  </div>
                </div>

                {/* Content Box */}
                <div className={`ml-16 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12'}`} data-id="element-235" data-mp="2wy38ee48xxg5">
                  <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl shadow-sm border border-white/10 hover:bg-white/10 transition-colors" data-id="element-236" data-mp="2nzrkijurldre">
                    <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider mb-1 block" data-id="element-237" data-mp="2a1t7piw3dpe0">
                      {item.subtitle}
                    </span>
                    <h3 className="text-xl font-bold text-white mb-3" data-id="element-238" data-mp="89okgkpjfg9m">
                      {item.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed" data-id="element-239" data-mp="c7uldc3p31mm">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}